import React, { useImperativeHandle } from 'react';
import { numericalSort } from 'utils/tables/sorters';
import { ReportWidget } from 'waypoint-types';
import { PDFExportable } from 'waypoint-utils/pdf/PDFExportable';

interface TableOfContentsWidgetProps {
    reportWidgets: ReportWidget[] | null;
}

export const TableOfContentsWidget = React.forwardRef<
    PDFExportable,
    TableOfContentsWidgetProps
>(({ reportWidgets }: TableOfContentsWidgetProps, ref) => {
    useImperativeHandle(ref, () => ({
        isReadyToExport(): boolean {
            return true;
        },
    }));

    return (
        <div>
            {reportWidgets
                ?.filter((widget) => widget.sort_index >= 0)
                .sort((a, b) => numericalSort(a.sort_index, b.sort_index))
                .map((widget, index) => (
                    <div
                        style={{ marginTop: '10px', fontSize: '20px' }}
                    >{`${index + 1}. ${widget.name}`}</div>
                ))}
        </div>
    );
});
